





































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { GridModel } from '@/core/models';

@Component
export default class GridPagerCpt extends Vue {
  @Prop() grid: GridModel<any, any>;

  visiblePages = [] as number[];

  calculatePages() {
    this.visiblePages = [];
    let startPage = Math.max(1, this.grid.filter.page - 2);
    let endPage = Math.min(this.grid.collection.pageCount, this.grid.filter.page + 2);

    if (this.grid.filter.page <= 3) {
      endPage = Math.min(5, this.grid.collection.pageCount);
    } else if (this.grid.filter.page >= this.grid.collection.pageCount - 2) {
      startPage = Math.max(this.grid.collection.pageCount - 4, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      this.visiblePages.push(i);
    }
  }

  created() {
    this.$eventHub.$on('GRID_DATA_UPDATED', () => {
      this.calculatePages();
      this.$forceUpdate();
    });
  }

  onChange(page: number) {
    this.grid.goToPage(page);
  }
}
